(function () {
  if (window.__sidecartFeaturesInit) return;
  window.__sidecartFeaturesInit = true;

  // ---------- helpers ----------

  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '';

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    if (moneyFormat) {
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, v)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.replace('.', ','));
    }
    return '$' + v;
  }

  function formatUnit(v) {
    return Math.max(0, Math.round(v));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- progress bar ----------

  function initProgressBar(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var total = parseFloat(root.dataset.cartTotal) || 0;
    var currencySymbol = root.dataset.currencySymbol || '';

    var tiers = [
      { value: parseFloat(root.dataset.tier1) || 0, label: root.dataset.tier1Label || '' },
      { value: parseFloat(root.dataset.tier2) || 0, label: root.dataset.tier2Label || '' },
      { value: parseFloat(root.dataset.tier3) || 0, label: root.dataset.tier3Label || '' }
    ]
      .filter(function (t) { return t.value > 0; })
      .sort(function (a, b) { return a.value - b.value; });

    if (!tiers.length) {
      root.style.display = 'none';
      return;
    }

    var max = tiers[tiers.length - 1].value;

    var markers = root.querySelectorAll('[data-marker]');
    tiers.forEach(function (t, i) {
      var marker = markers[i];
      if (!marker) return;
      var percent = (t.value / max) * 100;
      marker.style.left = percent + '%';
      var labelEl = marker.querySelector('.cart-progress__marker-label');
      if (labelEl) labelEl.textContent = t.label;
      marker.style.display = '';
      marker.classList.toggle('is-reached', total >= t.value);
    });
    for (var i = tiers.length; i < markers.length; i++) {
      markers[i].style.display = 'none';
    }

    var fillPercent = Math.min(100, (total / max) * 100);
    var fillEl = root.querySelector('[data-cart-progress-fill]');
    if (fillEl) fillEl.style.width = fillPercent + '%';

    var msgEl = root.querySelector('[data-cart-progress-message]');
    if (msgEl) {
      var nextTier = null;
      for (var j = 0; j < tiers.length; j++) {
        if (total < tiers[j].value) { nextTier = tiers[j]; break; }
      }
      if (nextTier) {
        var remaining = nextTier.value - total;
        msgEl.innerHTML =
          'Add <strong>' + currencySymbol + formatUnit(remaining) + '</strong> more to unlock <strong>' + escapeHtml(nextTier.label) + '</strong>';
      } else {
        var last = tiers[tiers.length - 1];
        msgEl.innerHTML = 'You unlocked all rewards including <strong>' + escapeHtml(last.label) + '</strong>!';
      }
    }
  }

  // ---------- recommendations ----------

  function renderCards(container, products) {
    if (!products || !products.length) {
      container.innerHTML = '<div class="cart-recs__empty">No recommendations available.</div>';
      return;
    }

    var html = products.map(function (p) {
      var img = p.featured_image;
      if (img && typeof img === 'object' && img.src) img = img.src;
      if (!img && p.images && p.images[0]) {
        img = typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
      }
      var priceHtml = formatMoney(p.price);
      var singleVariant = p.variants && p.variants.length === 1;
      var firstAvailable = null;
      if (p.variants) {
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { firstAvailable = p.variants[i]; break; }
        }
        if (!firstAvailable) firstAvailable = p.variants[0];
      }
      var variantId = firstAvailable ? firstAvailable.id : '';

      return '' +
        '<div class="cart-recs__card" data-product-handle="' + escapeHtml(p.handle) + '">' +
          '<a class="cart-recs__thumb" href="/products/' + escapeHtml(p.handle) + '" tabindex="-1">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '<span class="cart-recs__thumb-placeholder"></span>') +
          '</a>' +
          '<div class="cart-recs__body">' +
            '<a class="cart-recs__title" href="/products/' + escapeHtml(p.handle) + '">' + escapeHtml(p.title) + '</a>' +
            '<div class="cart-recs__price">' + priceHtml + '</div>' +
            '<button type="button" class="cart-recs__add" data-add-btn data-variant-id="' + variantId + '" data-product-handle="' + escapeHtml(p.handle) + '" data-single-variant="' + (singleVariant ? '1' : '0') + '">+ Add</button>' +
            '<div class="cart-recs__variants" data-variants-container hidden></div>' +
          '</div>' +
        '</div>';
    }).join('');

    container.innerHTML = html;
    container._products = products;
  }

  function findProduct(container, handle) {
    var products = container._products || [];
    for (var i = 0; i < products.length; i++) {
      if (products[i].handle === handle) return products[i];
    }
    return null;
  }

  function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          btn.textContent = 'Unavailable';
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1600);
          return;
        }
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1400);
      })
      .catch(function () {
        btn.textContent = 'Failed';
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1600);
      });
  }

  function initRecs(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var productId = root.dataset.productId;
    var limit = root.dataset.limit || 6;
    var intent = root.dataset.intent || 'complementary';
    var strip = root.querySelector('[data-cart-recs-strip]');
    if (!productId || !strip) return;

    var url =
      '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=' + encodeURIComponent(intent);

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCards(strip, data.products || []); })
      .catch(function () {
        strip.innerHTML = '';
        root.style.display = 'none';
      });
  }

  // ---------- delegated events (survive DOM replacement) ----------

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-btn]');
    if (!btn) return;
    var card = btn.closest('.cart-recs__card');
    var container = card ? card.parentElement : null;
    if (!container) return;
    var product = findProduct(container, btn.dataset.productHandle);
    if (!product) return;

    var single = btn.dataset.singleVariant === '1' || product.variants.length === 1;
    if (single) {
      addToCart(btn.dataset.variantId, 1, btn);
      return;
    }

    var picker = card.querySelector('[data-variants-container]');
    if (!picker) return;
    if (!picker.hidden) { picker.hidden = true; return; }

    picker.innerHTML = product.variants.map(function (v) {
      var disabled = !v.available;
      return '<button type="button" class="cart-recs__variant" data-variant-pick="' + v.id + '"' +
        (disabled ? ' disabled' : '') + '>' + escapeHtml(v.title) + (disabled ? ' — sold out' : '') + '</button>';
    }).join('');
    picker.hidden = false;
  });

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-variant-pick]');
    if (!pick) return;
    var card = pick.closest('.cart-recs__card');
    var btn = card ? card.querySelector('[data-add-btn]') : null;
    if (!btn) return;
    addToCart(pick.dataset.variantPick, 1, btn);
    var picker = pick.closest('[data-variants-container]');
    if (picker) picker.hidden = true;
  });

  // ---------- scan the DOM ----------

  function scan() {
    document.querySelectorAll('[data-cart-progress]').forEach(initProgressBar);
    document.querySelectorAll('[data-cart-recs]').forEach(initRecs);
  }

  // Watch for new instances (SRA drops fresh nodes without executing inline scripts).
  var observer = new MutationObserver(function () { scan(); });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('cart:updated', scan);
  document.addEventListener('cart:refresh', scan);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
